import { FC, useState, useCallback } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { orderFeedbackEvent } from '../tracking/orderFeedbackTracking';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { SellerReviewsModalAsync } from 'dibs-seller-reviews-modal/exports/SellerReviewsModalAsync';

// components
import { Link } from 'dibs-elements/exports/Link';

// types
import { PdpSharedDealerDetailsFeedback_seller$data as Seller } from './__generated__/PdpSharedDealerDetailsFeedback_seller.graphql';

// styles
import styles from './PdpSharedDealerDetailsFeedback.scss';

type Props = {
    seller: Seller;
    isMobile: boolean;
};

const PdpSharedDealerDetailsFeedbackComponent: FC<Props> = ({ seller, isMobile }) => {
    const { orderFeedbackPdp: reviews, serviceId } = seller || {};
    const numberOfReviews = reviews?.totalResults;
    const [isReviewsModalOpen, setIsReviewModalOpen] = useState(false);

    const openModal = useCallback(() => {
        orderFeedbackEvent({
            action: 'seller reviews expanded',
            label: 'pdp',
        });
        setIsReviewModalOpen(true);
    }, []);

    const onCloseModal = useCallback(() => {
        setIsReviewModalOpen(false);
    }, []);

    if (!numberOfReviews) {
        return null;
    }

    return (
        <>
            <Link
                onClick={openModal}
                className={styles.reviewsLink}
                dataTn="order-feedback-modal-trigger"
            >
                <FormattedMessage
                    id="PdpSharedDealerDetailsFeedback.seeReviews"
                    defaultMessage="{numberOfReviews, plural, one {# Review} other {# Reviews}}"
                    values={{ numberOfReviews }}
                />
            </Link>

            <SellerReviewsModalAsync
                isOpen={isReviewsModalOpen}
                onClose={onCloseModal}
                sellerId={serviceId}
                isMobileScrollContainer={isMobile}
            />
        </>
    );
};

export const PdpSharedDealerDetailsFeedback = createFragmentContainer(
    PdpSharedDealerDetailsFeedbackComponent,
    {
        seller: graphql`
            fragment PdpSharedDealerDetailsFeedback_seller on Seller {
                serviceId
                orderFeedbackPdp {
                    totalResults
                    edges {
                        node {
                            serviceId
                        }
                    }
                }
            }
        `,
    }
);
